import request from './requestWrapper';

// Types
import {OrderPaginationType} from "../types/orderTypes";


function getParams() {
  return request({
    url: `order/getParams`,
    method: 'GET',
  });
}
function getDetailByOrderNumber(orderNumber: string) {
  return request({
    url: `order/getDetailByOrderNumber/${orderNumber}`,
    method: 'GET',
  });
}
function getAll(data: OrderPaginationType) {
  return request({
    url: 'order/getAll',
    method: 'POST',
    data: data
  });
}
function deleteByOrderNumber(orderNumber: string) {
  return request({
    url: `order/deleteOrder/${orderNumber}`,
    method: 'DELETE',
  });
}

export default {
  getParams,
  getAll,
  getDetailByOrderNumber,
  deleteByOrderNumber
}